var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketArrowDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707483924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "var(--fill-0, #DEDEDE)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M27.8994 37.799L37.7989 27.8995L27.8994 18M37.7989 27.8995H17.9999",
    stroke: "var(--stroke-0, #707070)",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketArrowDefault);
export default __webpack_public_path__ + "static/media/market-arrow-default.5243b914ce6fa307bac0c86234248ec0.svg";
export { ForwardRef as ReactComponent };